module.exports = __webpack_public_path__ + "img/lang-arrow-down.5249d4fc.svg";